<style src="@/assets/styles/components/modules/hosted-pages/discount.styl" lang="stylus" scoped></style>
<template>
  <div class="cb-discount cb-transition__tab" id="cb-discount" ref="parent">
    <cb-toggle :parent="$refs.parent">
      <div class="cb-discount__action" v-cb-link="'color'" @click="showDiscountBox($event)" :class="{'cb-discount__action--center': centerAlign}" v-if="!discountBoxShown" key="action">{{ ct('coupon.label') }}</div>
      <div class="cb-text" v-else key="input" tabindex="-1">
        <label class="cb-text__label" for="coupon-code" :style="themeColor"></label>
        <input ref="x1" class="cb-text__control cb-text__control--left" :class="{'cb-text__control--error': couponErrorMessage && couponErrorMessage.length > 0}" type="text" v-model="couponCode" :placeholder="ct('coupon.placeholder')" @keyup.enter="applyCoupon()" @keyup="clearCouponError()" id="coupon-code">
        <transition name="fade">
          <button-field class="cb-transition__fade" v-if="couponCode && couponCode.length > 0" @next="applyCoupon" :custom-class="'primary icon field'" :showLoader="showDiscountButtonLoader" :attr="'coupon_submit'">
            <i class="icon-long-arrow-right"></i>
          </button-field>
        </transition>
      </div>
    </cb-toggle>
    <cb-slide-n-fade>
      <div class="cb-text__error" :class="{'cb-text__error--center':centerAlign}" v-if="couponErrorMessage">
        {{couponErrorMessage}}
      </div>
    </cb-slide-n-fade>
  </div>
</template>
<script type="text/javascript">
import Vue from "vue";
import { mapGetters } from "vuex";
import Button from "@/components/collections/form/ButtonComponent";
import { EventBus } from "@/utils/event-bus";
export default {
  components: {
    "button-field": Button
  },
  props: ["centerAlign"],
  data() {
    return {
      discountBoxShown: false,
      couponErrorMessage: "",
      couponCode: undefined,
      showDiscountButtonLoader: false
    };
  },
  mounted() {
    if (this.$store.getters.ui_config["coupon_section.default.open"]) {
      this.discountBoxShown = true;
    }
  },
  methods: {
    showDiscountBox() {
      this.discountBoxShown = true;
      window.cbTimeout(() => {
        this.$refs.x1 && this.$refs.x1.focus();
      }, 400); //400 animation duration
    },
    applyCoupon(event) {
      if (!this.couponCode) {
        return;
      }
      this.showDiscountButtonLoader = true;
      this.$store
        .dispatch("apply_coupon", this.couponCode)
        .then(success => {
          if (success) {
            EventBus.$emit("hp_log", {
              action: "coupon_applied",
              code: this.couponCode
            });
            window.setTimeout(function() {
              EventBus.setPrevHeight();
            }, 400);
            this.discountBoxShown = false;
            this.couponErrorMessage = "";
            this.couponCode = "";
            this.showDiscountButtonLoader = false;
          } else {
            this.discountBoxShown = false;
            this.showDiscountButtonLoader = false;
          }
        })
        .catch(error => {
          this.couponErrorMessage =
            error.paramMessage ||
            (error.status == 400 && "Invalid Coupon Code");
          this.$store.dispatch("remove_coupon_no_side_effect");
          this.showDiscountButtonLoader = false;
          EventBus.$emit("hp_log", {
            action: "coupon_failed",
            code: this.couponCode,
            error: error
          });
          logger.e(error);
        });
    },

    clearCouponError() {
      if (this.$refs.x1.value.length == 0) this.couponErrorMessage = "";
    }
  }
};
</script>



// WEBPACK FOOTER //
// DiscountComponent.vue?14f22f46